'use client';

import { useCareStateDomain } from '@/entities/care-state-domain';
import { useUserInfoQuery } from '@/entities/user-info';
import { CortexPromptStrip } from '@/features/cortex-prompts';

import { ProblemListCard } from './ProblemListCard';

function firstName(fullName: string): string {
  const trimmed = fullName.trim();
  if (trimmed.length === 0) return '';
  const [first = ''] = trimmed.split(/\s+/);
  return first;
}

export interface ProblemHistoryTabProps {
  userId: string;
}

export function ProblemHistoryTab({ userId }: ProblemHistoryTabProps) {
  const { careState } = useCareStateDomain();
  const userInfoQuery = useUserInfoQuery(userId);

  const patientFirstName = firstName(userInfoQuery.data?.patientInfo?.name ?? '');
  const possessiveName = patientFirstName.length > 0 ? `${patientFirstName}'s ` : '';

  const problems = careState?.problems ?? [];

  return (
    <div className="flex flex-col gap-4">
      <header className="flex flex-col gap-1">
        <h2 className="text-lg font-medium leading-tight tracking-tight">
          <span className="text-muted-foreground">{possessiveName}</span>
          <span className="text-foreground">problem history</span>
        </h2>
        <p className="text-sm text-muted-foreground">
          Intelligently generated by Cortex AI based on the patient&apos;s chart and interactions
          with Lotus AI.
        </p>
      </header>

      <CortexPromptStrip />

      <div className="flex flex-col gap-3">
        {problems.map((problem) => (
          <ProblemListCard key={problem.id} problem={problem} />
        ))}
      </div>
    </div>
  );
}
